import { render } from "./multi-store.vue?vue&type=template&id=04f5e14c"
import script from "./multi-store.vue?vue&type=script&lang=js"
export * from "./multi-store.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__